import { isFuture, isPast, parseISO } from 'date-fns';

import {
  SeriesTicketType,
  State,
  TicketType,
} from '../features/event-details/event-detail-types';
import { SelectedTicketItemType } from '../features/select-tickets/cart-types';

export const hasSingleTicketSelected = (
  selectedTickets: SelectedTicketItemType[],
) =>
  (selectedTickets.length === 1 && selectedTickets[0].quantity === 1) || false;

export const isClosed = (firstTicket: TicketType, eventDetails: State) => {
  const salesDateInvalid =
    firstTicket.salesEndTime &&
    firstTicket.salesStartTime &&
    (isFuture(parseISO(firstTicket.salesStartTime)) ||
      isPast(parseISO(firstTicket.salesEndTime)));
  !eventDetails.settings ||
    isPast(parseISO(eventDetails.settings.registrationCloseTime));
  !eventDetails.settings ||
    isPast(parseISO(eventDetails.settings.registrationCloseTime));

  const isRegistrationClosed =
    !eventDetails.settings ||
    isPast(parseISO(eventDetails.settings.registrationCloseTime));

  const regLimitReached =
    !eventDetails.settings ||
    (eventDetails.settings.maxRegistrations !== null &&
      eventDetails.event.totalUsersRegistered >=
        eventDetails.settings.maxRegistrations);

  const eventHasEnded = isPast(parseISO(eventDetails.event.endTime));

  const ticketRegLimitReached = firstTicket.registrationsLimit
    ? firstTicket.currentRegistrations >= firstTicket.registrationsLimit
    : false;

  return (
    status === 'closed' ||
    salesDateInvalid ||
    isRegistrationClosed ||
    regLimitReached ||
    eventHasEnded ||
    ticketRegLimitReached
  );
};

export const isValidTicketAvailable = (ticket: SeriesTicketType) => {
  return (
    ticket.salesActive && ticket.remaining > 0 && ticket.status !== 'closed'
  );
};

export const findCheapestTicket = (tickets: SeriesTicketType[]) => {
  const validTickets = tickets.filter(isValidTicketAvailable);
  // if there are no valid tickets, return null
  if (validTickets.length === 0) {
    return null;
  }

  // find the cheapest one
  return validTickets.reduce((ticket, current) => {
    if (!ticket || current.price < ticket.price) {
      return current;
    }
    return ticket;
  }, null as SeriesTicketType | null);
};
